import { Controller } from "stimulus"

export default class extends Controller {
  toggleForm({ target }) {
    const hide = target.dataset.hide
    const newDistributorForm = document.getElementById('new_distributor');
    newDistributorForm.classList.toggle('d-none', hide);
  }
}
